import React from 'react';

const Navbar = () => {
  return (
    <nav className="hidden md:block min-h-[10vh] p-4 flex justify-left">
      <h1 className="text-black font-light text-2xl">Christian Bingman</h1>
    </nav>
  );
};

export default Navbar;
